module.exports = __webpack_public_path__ + "img/FJ.a5fe73c1.svg";